<template>
  <v-container>
    <v-card>
      <v-card-title class="headline font-weight-regular blue-grey white--text">
        Grocery List
      </v-card-title>
    </v-card>
    <v-card class="table-card pa-4">
      <h2>Today: {{ weekdays[today] }}</h2>
      Next Pickup: {{ weekdays[pickup] }}
      <br><br>
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
      <div v-if="!loading">
        <div class="headers">
          <div class="cell">Name</div>
          <div class="cell">Required</div>
          <div class="cell">Inventory</div>
          <div class="cell">Delta</div>
          <div class="cell">Net Size</div>
          <div class="cell">Order Qty.</div>
          <div class="cell">Action</div>
        </div>
        <div v-for="item in food" :key="item.id">
          <div v-if="confirmed.indexOf(item.id) == -1" class="row">
            <!-- Item Name -->
            <div class="cell">{{ item.name }}</div>
            <!-- Portion Required -->
            <div class="cell">
              {{ Math.round(item.portionAmount*item.serving*100)/100 }} {{ item.unit }}
            </div>
            <!-- Existing Inventory -->
            <div class="cell">
              <v-text-field v-model="item.inventory" :suffix="item.unit"></v-text-field>
            </div>
            <!-- Difference -->
            <div class="cell">
              <div v-if="(item.inventory - (item.portionAmount*item.serving)) > 0" class="green--text">
                {{ Math.round((item.inventory - (item.portionAmount*item.serving))*100)/100 }} {{ item.unit }}
              </div>
              <div v-else class="red--text">
                {{ Math.round((item.inventory - (item.portionAmount*item.serving))*100)/100 }} {{ item.unit }}
              </div>
            </div>
            <!-- Net Size -->
            <div class="cell">
              {{ item.net }} {{ item.unit }}
            </div>
            <!-- Order Quantity -->
            <div class="cell">
              <v-text-field v-model="item.order"></v-text-field>
            </div>
            <!-- Actions -->
            <div class="cell">
              <v-btn flat icon color="primary" @click="confirm(item)">
                <v-icon>done</v-icon>
              </v-btn>
            </div>
          </div>
          <div v-else class="row">
            <div class="cell grey--text">{{ item.name }}</div>
            <div class="cell"></div>
            <div class="cell"></div>
            <div class="cell"></div>
            <div class="cell"></div>
            <div class="cell"></div>
            <div class="cell">
              <v-btn flat icon color="primary" @click="undo(item)">
                <v-icon>undo</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <!-- Shopping List -->
      <!-- <div v-if="components.length == confirmed.length && !loading" class="shoppingList"> -->
      <div class="shoppingList">
        <div class="headers">
          <div class="cell">Name</div>
          <div class="cell">Order Qty.</div>
          <div class="cell">Order Amount</div>
          <div class="cell">Price</div>
          <div class="cell">Action</div>
        </div>
        <div v-for="item in shoppingList" :key="item.id" class="row">  
          <div class="cell">{{ item.name }}</div>
          <div class="cell">{{ item.order }}</div>
          <div class="cell">{{ item.order * item.net }} {{ item.unit }}</div>
          <div class="cell">${{ item.price * item.order }}</div>
          <div class="cell">
            <v-btn flat icon color="primary" :href="item.url" target="_blank">
              <v-icon>shopping_cart</v-icon>
            </v-btn>
            <v-btn flat icon color="primary" @click="stock(item)">
              <v-icon>done</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="cell total">Sub-Total</div>
          <div class="cell total">${{ computedOrderTotal }}</div>
        </div>
        <div class="row">
          <div class="cell total">Tax</div>
          <div class="cell total">${{ Math.round(computedOrderTotal * 0.13 * 100)/100 }}</div>
        </div>
        <div class="row">
          <div class="cell total">Grand-Total</div>
          <div class="cell total">${{ Math.round(computedOrderTotal * 1.13 * 100)/100 }}</div>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import db from '@/firebase/firestore'
import moment from 'moment'
export default {
  name: 'Shopping',
  data() {
    return {
      today: 0,
      plan: [],
      meals: [],
      components: [],
      food: [],
      confirmed: [],
      pickup: 0,
      loading: true,
      shoppingList: [],
      weekdays: [
        '',
        'Monday, Week 1',
        'Tuesday, Week 1',
        'Wednesday, Week 1',
        'Thursday, Week 1',
        'Friday, Week 1',
        'Saturday, Week 1',
        'Sunday, Week 1',
        'Monday, Week 2',
        'Tuesday, Week 2',
        'Wednesday, Week 2',
        'Thursday, Week 2',
        'Friday, Week 2',
        'Saturday, Week 2',
        'Sunday, Week 2',
      ],
      headers: [
        { text: 'Item Name', value: 'name' },
        { text: 'Required Amount', value: 'serving' },
        { text: 'Inventory', value: 'net' },
        { text: 'Difference', value: 'difference' },
        { text: 'Order Qty', value: 'inventory' },
        { text: 'Order Amount', value: 'action' }
      ],
      pagination: {
        rowsPerPage: -1 // -1 for All
      },
      snack: false,
      snackColor: '',
      snackText: '',
    }
  },
  created() {
    // Determine the current day number
    this.today = moment(moment().diff('10/1/2018')).format('DDD') % 14
    if( this.today == 0 ) this.today = 14
    // Determine the next grocery day
    let plan = []
    let exclude = false
    let planRef = db.collection('plan').get().then((snapshot) => {
      // ---------------------- Create Ordered Short List ----------------------
      // JSON results come in unordered! So we add them to an associative
      // array with the key being the day number. This will result in an
      // ordered list.
      snapshot.forEach( doc => {
        let day = doc.data()
        if( day.day >= this.today ) plan[day.day] = day
        // console.log('day',day)
      })
      // console.log('plan',plan)
      // ---------------------- Determine Grocery Days ----------------------
      // The array is now in order so we can loop through it to determine
      // when the next grocery day is. Anything beyond that is not included.
      let shoppingDays = []
      let include = true
      plan.forEach( day => {
        if( day.day > this.today ) {
          if( day.groceries == true && include ) {
            include = false
            this.pickup = day.day
          }
        }
        if( include == true ) shoppingDays.push(day)
      })
      console.log('shoppingDays',shoppingDays)
      // ---------------------- 
      let meals = []
      shoppingDays.forEach( day => {
        // ---------- Morning Stack ----------
        if( day.aaron.morningStack.id ) {
          meals.push({
            id: day.aaron.morningStack.id,
            portion: parseFloat(day.aaron.morningStack.portion)
          })
        }
        if( day.ronan.morningStack.id ) {
          meals.push({
            id: day.ronan.morningStack.id,
            portion: parseFloat(day.ronan.morningStack.portion)
          })
        }
        // ---------- Breakfast ----------
        if( day.aaron.breakfast.id ) {
          meals.push({
            id: day.aaron.breakfast.id,
            portion: parseFloat(day.aaron.breakfast.portion)
          })
        }
        if( day.ronan.breakfast.id ) {
          meals.push({
            id: day.ronan.breakfast.id,
            portion: parseFloat(day.ronan.breakfast.portion)
          })
        }
        // ---------- Morning Snack ----------
        if( day.aaron.morningSnack.id ) {
          meals.push({
            id: day.aaron.morningSnack.id,
            portion: parseFloat(day.aaron.morningSnack.portion)
          })
        }
        if( day.ronan.morningSnack.id ) {
          meals.push({
            id: day.ronan.morningSnack.id,
            portion: parseFloat(day.ronan.morningSnack.portion)
          })
        }
        // ---------- Afternoon Stack ----------
        if( day.aaron.afternoonStack.id ) {
          meals.push({
            id: day.aaron.afternoonStack.id,
            portion: parseFloat(day.aaron.afternoonStack.portion)
          })
        }
        if( day.ronan.afternoonStack.id ) {
          meals.push({
            id: day.ronan.afternoonStack.id,
            portion: parseFloat(day.ronan.afternoonStack.portion)
          })
        }
        // ---------- Lunch ----------
        if( day.aaron.lunch.id ) {
          meals.push({
            id: day.aaron.lunch.id,
            portion: parseFloat(day.aaron.lunch.portion)
          })
        }
        if( day.ronan.lunch.id ) {
          meals.push({
            id: day.ronan.lunch.id,
            portion: parseFloat(day.ronan.lunch.portion)
          })
        }
        // ---------- Afternoon Snack ----------
        if( day.aaron.afternoonSnack.id ) {
          meals.push({
            id: day.aaron.afternoonSnack.id,
            portion: parseFloat(day.aaron.afternoonSnack.portion)
          })
        }
        if( day.ronan.afternoonSnack.id ) {
          meals.push({
            id: day.ronan.afternoonSnack.id,
            portion: parseFloat(day.ronan.afternoonSnack.portion)
          })
        }
        // ---------- Evening Stack ----------
        if( day.aaron.eveningStack.id ) {
          meals.push({
            id: day.aaron.eveningStack.id,
            portion: parseFloat(day.aaron.eveningStack.portion)
          })
        }
        if( day.ronan.eveningStack.id ) {
          meals.push({
            id: day.ronan.eveningStack.id,
            portion: parseFloat(day.ronan.eveningStack.portion)
          })
        }
        // ---------- Dinner ----------
        if( day.aaron.dinner.id ) {
          meals.push({
            id: day.aaron.dinner.id,
            portion: parseFloat(day.aaron.dinner.portion)
          })
        }
        if( day.ronan.dinner.id ) {
          meals.push({
            id: day.ronan.dinner.id,
            portion: parseFloat(day.ronan.dinner.portion)
          })
        }
        // ---------- Evening Snack ----------
        if( day.aaron.eveningSnack.id ) {
          meals.push({
            id: day.aaron.eveningSnack.id,
            portion: parseFloat(day.aaron.eveningSnack.portion)
          })
        }
        if( day.ronan.eveningSnack.id ) {
          meals.push({
            id: day.ronan.eveningSnack.id,
            portion: parseFloat(day.ronan.eveningSnack.portion)
          })
        }
      })
      // console.log('meals',meals)
      this.meals = meals
      // ---------------------- Get Components ----------------------
      let count = 0
      let response = []
      this.meals.forEach( meal => {
        if( meal.id ) {
          db.collection('meals').doc(meal.id).get().then((snapshot) => {
            let components = snapshot.data().components
            count++
            // console.log(meal.id, components)
            components.forEach( component => {
              if( response[component.id] ) {
                response[component.id].portion += (parseFloat(component.portion) * meal.portion)
                response[component.id].cost += (parseFloat(component.cost) * meal.portion)
              } else {
                component.portion = parseFloat(component.portion) * meal.portion
                component.cost = parseFloat(component.cost) * meal.portion
                response[component.id] = component
              }
            })
            if( this.meals != null && count == this.meals.length ) {
              // Flatten Array
              this.components = []
              for( var key in response ) {
                var value = response[key];
                this.components.push( value )
              }
              // console.log('components', this.components)
              let foods = []
              let counter = 0
              this.components.forEach( component => {
                let foodRef = db.collection('food').doc(component.id)
                foodRef.get().then( doc => {
                  counter++
                  let food = doc.data()
                  food.id = doc.id
                  // ---------- Calculate Order Quantity ----------
                  let delta = ((food.portionAmount * food.serving) - food.inventory) / food.net
                  food.order = delta ? Math.ceil(delta) : 0
                  // 
                  foods.push(food)
                  if( counter == this.components.length ) {
                    this.loading = false
                    // console.log(foods)
                    this.food = foods
                  }
                })
              })
            }
          })
          .catch( err => {
            console.log( 'meal', meal )
            console.log( 'Meal not found!', err)
          })
        }
      })
    })
  },
  computed: {
    computedOrderTotal() {
      let total = 0
      this.shoppingList.forEach( item => {
        total += Math.round(item.order * item.price * 100)/100
      })
      return total
    }
  },
  methods: {
    stock(item) {
      // ---------- Increase Inventory
      // console.log('old stock', item.inventory)
      item.inventory = item.order * item.net
      // console.log('new stock', item.inventory)
      // ---------- Update Record in Firebase
      let ref = db.collection('food')
      ref.doc(item.id).set(item).then(() => {
        // ---------- Remove from Shopping List
        this.removeFromShoppingList(item)  
        // ---------- Show Notification
        this.snack = true
        this.snackText = 'Inventory Updated'
      })
    },
    confirm(item) {
      // ---------- Check for inventory change
      // console.log('confirming item', item)
      let ref = db.collection('food')
      ref.doc(item.id).set(item).then(() => {
        // ---------- Add to Confirmation List
        this.confirmed.push(item.id)
        // ---------- Add to Shopping List
        if( item.order > 0 ) {
          this.shoppingList.push(item)
        }
        // console.log('shopppingList',this.shoppingList)
        // ---------- Show Notification
        this.snack = true
        this.snackText = 'Item Confirmed'
      })
    },
    undo(item) {
      // ---------- Remove from Confirmation List
      let index = this.confirmed.indexOf(item.id)
      if( index > -1 ) {
        this.confirmed.splice(index,1)
      }
      // ---------- Remove from Shopping List
      this.removeFromShoppingList(item)
    },
    removeFromShoppingList(item) {
      let index = -1
      let removeIndex = -1
      this.shoppingList.forEach( listItem => {
        index++
        if( listItem.id == item.id ) {
          removeIndex = index
        }
      })
      if( removeIndex > -1 ) {
        this.shoppingList.splice(removeIndex,1)
        if( this.shoppingList.length == 0 ) {
          // ---------- Add Grocery Shopping Record ----------
          db.collection('groceries').add({
            day: this.today,
            moment: moment().format('X'),
            date: moment().format("dddd, MMMM Do YYYY, h:mm:ss a"),
          }).then(() => {
            // ---------- Show Notification
            this.snack = true
            this.snackText = 'Shopping Complete!'
          })
        }
      }
    }
  }
}
</script>

<style scoped>
  .row {
    display: flex;
    flex-direction: row;
  }
  .row .cell {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    border-left: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
  }
  .row .cell:first-child {
    flex: 4;
    justify-content: left;
  }
  .row .cell:last-child {
    border-right: 1px solid #f5f5f5;
  }
  .headers {
    display: flex;
    flex-direction: row;
  }
  .headers .cell {
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: #f5f5f5;
    font-size: 10px;
    font-weight: bold;
  }
  .headers .cell:first-child {
    flex: 4;
    justify-content: left;
  }
  .cell.total:first-child {
    justify-content: flex-end;
    font-weight: bold;
    padding: 10px 20px;
  }
</style>
